import type { FC } from "react";
import { FrontendApiConfigProvider as FrontendApiConfigBaseProvider } from "@edreamsodigeo/frontend-api-client-base";

interface FrontendApiConfigProviderProps {
  graphQLEndpoint: string;
  schema: string;
}

export const FrontendApiConfigProvider: FC<FrontendApiConfigProviderProps> =
  FrontendApiConfigBaseProvider;
